import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const InvoiceNumberHeader = ({
  column,
}: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Re.-Nr."
      style={{ padding: "5px" }}
    />
  );
};
